import React from 'react';
import { withPage, TranslatedText } from "@sms/plasma-ui";
import * as styled from './CentralizedTextPage.styles';

export interface CentralizedTextPageProps {
  textKey: string;
}

const CentralizedTextPage: React.FC<CentralizedTextPageProps> = (props: CentralizedTextPageProps) => {
  return (
    <styled.Container>
      <styled.Text><TranslatedText textKey={props.textKey} /></styled.Text>
    </styled.Container>
  );
};

export default withPage(CentralizedTextPage);
